function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNWolontariat1 = function SvgNWolontariat1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.5 155.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0z",
    "data-name": "Warstwa 2",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.11 151.24H78.83V89.49c0-11.08-9.02-20.1-20.1-20.1s-20.1 9.02-20.1 20.1v61.75H14.36V89.49c0-24.47 19.91-44.37 44.37-44.37s44.38 19.91 44.38 44.37z",
    "data-name": "Warstwa 1",
    style: {
      fill: "#ffb900"
    }
  }));
};
export default SvgNWolontariat1;